<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 33 41" fill="currentColor">
    <path fill-rule="evenodd" clip-rule="evenodd"
      d="M16.5001 0.491699C10.494 0.491699 5.62514 5.36061 5.62514 11.3667C5.62514 16.3253 8.94386 20.5088 13.4813 21.8172C9.89923 22.2537 6.82685 23.5207 4.51235 25.8017C1.56662 28.7049 0.0751953 33.0267 0.0751953 38.6664C0.0751953 39.4536 0.713206 40.0914 1.5002 40.0914C2.28722 40.0914 2.9252 39.4536 2.9252 38.6664C2.9252 33.5064 4.28372 30.0285 6.51287 27.8316C8.74621 25.6306 12.0804 24.4917 16.5 24.4917C20.9196 24.4917 24.2539 25.6306 26.4874 27.8316C28.7164 30.0285 30.0751 33.5064 30.0751 38.6664C30.0751 39.4536 30.7129 40.0914 31.5001 40.0914C32.287 40.0917 32.9251 39.4536 32.9251 38.6667C32.9251 33.0267 31.4335 28.7049 28.4878 25.8017C26.1733 23.5208 23.1009 22.2538 19.5189 21.8173C24.0562 20.5089 27.3751 16.3254 27.3751 11.3667C27.3751 5.36061 22.5062 0.491699 16.5001 0.491699ZM8.47513 11.3667C8.47513 6.93462 12.0681 3.3417 16.5001 3.3417C20.9322 3.3417 24.5251 6.93462 24.5251 11.3667C24.5251 15.7988 20.9322 19.3917 16.5001 19.3917C12.0681 19.3917 8.47513 15.7988 8.47513 11.3667Z"
    />
  </svg>
</template>

<style scoped>
svg {
  color: #59E3FF;
  transition: color 0.3s ease-in-out;
}
</style>
